import isEmpty from 'helpers/is-empty'
import { getSessionStorage } from 'helpers/session-storage'
import { NO_BACK_URLS, PREV_PATHS } from 'constants/routing'
import { PathQueryType } from '~/contexts/RoutingContext'

// Reads directly from the browser URL rather than next/router's query
// object — next/router.query can lag behind the actual URL until the
// router finishes hydrating, which is too late for callers (e.g. an
// invite-link visitor) that need the value on the very first render.
export function getUrlQueryParam(key: string): string {
  if (typeof window === 'undefined') return ''
  return new URLSearchParams(window.location.search).get(key) || ''
}

export function getPreviousURL(): string {
  let basePaths = getSessionStorage(PREV_PATHS) as PathQueryType[]
  if (isEmpty(basePaths)) {
    return '/'
  }
  if (
    NO_BACK_URLS.some((blockedRoute) =>
      basePaths
        .map((val) => val.path)
        .some((path) => path.includes(blockedRoute)),
    )
  ) {
    return '/'
  }
  const lastPath = basePaths.pop()
  return lastPath?.path || '/'
}
